<template>
  <div>
    <about-view />
    <div id="apps">
      <section class="section has-text-white">
        <h1 class="title is-3 has-text-white"><font-awesome-icon :icon="['fas', 'mobile']" /> Published Apps</h1>
        <div class="container">
          <div class="columns">
            <div class="column is-6">
              <img src="https://storage.googleapis.com/bluegiraffelabs_web/trifectayum_web_banner.png">
              <img alt="download_1" src="../assets/appledownload.png" width=150px @click="goToTYAppStore">
              <img alt="download_1" src="../assets/googledownload.png" width=150px @click="goToTYPlayStore">
            </div>
            <div class="column">
              <img src="https://storage.googleapis.com/bluegiraffelabs_web/littleauthor_web_banner.png">
              <img alt="download_1" src="../assets/appledownload.png" width=150px @click="goToLAAppStore">
              <img alt="download_1" src="../assets/googledownload.png" width=150px @click="goToLAPlayStore">
            </div>
          </div>
        </div>
      </section>
    </div>

    <div id="contact">
      <section class="section">
        <p class="title is-3 has-text-white"><font-awesome-icon :icon="['fas', 'envelope']" /> Contact</p>
        <p class="subtitle is-5 has-text-white">For product support or questions: <a href="mailto:info@bluegiraffelabs.com">info@bluegiraffelabs.com</a></p>
        <p><img alt="download_1" src="../assets/bmc-button.png" width=200px @click="goToBuyMeCoffee"></p>
      </section>
    </div>
  </div>
</template>

<script>
import AboutView from './About.vue'
import ContactView from './Contact.vue'

export default {
  name: 'home',
  components: {
    AboutView,
    ContactView
  },
  methods: {
    goToTYAppStore() {
      window.open("https://apps.apple.com/app/trifecta-yum/id6446237555", '_blank');
    },
    goToTYPlayStore() {
      window.open("https://play.google.com/store/apps/details?id=com.bluegiraffelabs.trifectayum", '_blank');
    },
    goToLAAppStore() {
      window.open("https://apps.apple.com/app/little-author/id6449449234", '_blank');
    },
    goToLAPlayStore() {
      window.open("https://play.google.com/store/apps/details?id=com.bluegiraffelabs.littleauthor", '_blank');
    },
    goToBuyMeCoffee() {
      window.open('https://www.buymeacoffee.com/bluegiraffelabs', '_blank');
    }
  }
}
</script>

<style>
.display_section {
  padding: 20px;
  border: 5px solid #f1f1f1;
  color: #fff;
}

.sentence-margin {
  margin: 5px;
  padding: 10px;
}
</style>
